import Vue from 'vue'
import VueI18n from 'vue-i18n'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'

import router from './router'
import store from './store'

import App from './App.vue'
//import Home from './pages/Home.vue'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'tw',
  messages: {
    'en': require('./i18n/en.json'),
    'tw': require('./i18n/tw.json')
  }
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js